import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import { RemindRespondentsDialog } from 'modules/engagement_surveys/components/RemindRespondentsDialog'

type Data = {
  surveyId: string
  formId: string
}

export const RemindRespondentsActivity: ActivityComponent<Data> = ({ surveyId, formId }) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  return (
    <RemindRespondentsDialog
      surveyId={surveyId}
      formId={formId}
      onSuccess={closeActivity}
      onCancel={closeActivity}
    />
  )
}
